// extracted by mini-css-extract-plugin
export default {"action":"ModalAction_action__eUwEC","border_2px":"ModalAction_border_2px__kHuz6","disable_action":"ModalAction_disable_action__7GUlW"};